module.exports = __webpack_public_path__ + "img/PVP_CeltTechSacredDeer_Upgrade1.71b8aeb6.webp";